module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("My windows and door were open to create a breeze. I poured sweating curls of cheese into a trash bag and brushed crumbs off the desktop. I was watching a videotape on a television hidden in a corner cabinet. It was a compilation of news footage about the two cases that had put me on the map. It had arrived giftwrapped with a “Congratulations on Your New Job” greeting card. The card was bare of salutation or comment and was signed simply “Aunt Diana.” I was sure she hadn’t made the tape herself. “Uncle” Henry (my father’s second cousin, as close to him as a brother) had probably forgotten it with his post-divorce leavings.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Though Diana would ordinarily have loved gloating about a famous relative, she loathed me. She couldn’t be overt about it—I added to her stature, after all. Hence, a gift not of her making and a merely civil card.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I tossed the card into the garbage. She could have added a line about her son.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Hal and I had grown up in mutual dislike and conflict. When we fell in love decades later, we discussed little. Any subject might become a mine field of old jealousies and irritations. We spent four hard years together. Three months ago, he left. Just gave up on us and left. Funny I could miss him so much and yet find life without him a relief.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’d traced him to Alaska, to an artsy little nowhere called Homer. Diana might have let me know whether the family had heard from him.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("On my television screen, I explained a defense strategy to reporters who’d consistently mischaracterized it.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The image in the box didn’t match the one in my mirror. The mirror gave me back a slim woman, obviously of Italian descent: nose a little large, lips full, Joan Crawford brows over green eyes, few white hairs among the brown. Yet the Dorian Gray on my television looked disconcertingly heavier, older, unflatteringly strident under her ice. I listened to my explanation of the “television syndrome” defense: that television creates a reality more powerful than personal experience. I watched, measuring the truth of my argument by the battering my self-image was taking.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("A voice interrupted. “Laura? I took a chance on finding you in.” .")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Margaret.” I was surprised to see Graystone Federal’s in-house counsel at my door. She’d registered in my consciousness this morning only as part of a group I’d written off.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Do you have time right now?” Her gaunt face seemed unnaturally tight. Not a face lift? She was about forty, about my age; surely she was too young? She blinked rapidly, anchoring a smooth wave of hair behind her ear.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Please come in.” I clicked off the television, letting the videotape wind on. I’d seen enough.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I motioned Margaret into a cheap chair. There were round aluminum trays on my desk, bare of their Safeway cold cuts. I placed them on the floor. “Is this social? Or a bank problem?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I tried not to get my hopes up. She probably couldn’t hire co-counsel without a vice president’s approval. And Graystone’s VP, as far as I knew, was a White, Sayres loyalist.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“It’s a personal problem.” She was seated now, as long and flat as a ribbon in the hard fabric chair. With her belted knit dress and sleek forties hair, she looked like a fragile film-noir heroine. I remembered her as having an edge-of-the-chair, health-club vitality. Her languidness surprised me.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Tell me about it.” I sat back, expecting to hear about a botched lease or a minor car accident.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“For the record”—she fixed me with bright eyes— “I’d like to hire you. I’d like you to be my lawyer.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("For the record: telling me the lawyer-client privilege was kicking in.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“My fee is ten percent lower than what I billed at White, Sayres. Is that all right?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Yes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I’ll have an agreement typed up and sent to you. This consultation is on me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Thank you.” There was a quality in her look that startled me. I didn’t know how to read it. Fear? Shame? “I’ve been walking around with this for days, not knowing who to contact. I can’t imagine going to any of the firms I know. I know so many people.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She knew me. Why was I different?")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“The rumor is you went off to Seattle or someplace, Laura. Is that right?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Northern California. Up near the Oregon border.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“And you didn’t practice at all?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“My … cousin was sick. I stayed with him.” It wasn’t a lie, but it came nowhere near the truth. Hal had been battling right-side weakness from the flare-up of an old Vietnam War injury. But that wasn’t what we’d hoped to heal, in our country cabin.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“And you didn’t go back to White. I guess I need to think you’ve been going through this lawyer thing like the rest of us.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Lawyer thing?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Did you see in ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("California Lawyer")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" that seventy percent of the lawyers they polled hate their careers and want to leave?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“No. I’ve been out of the loop.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You’re lucky. I haven’t had a real vacation in seven years. If Graystone had its way, I’d do nothing but work. Work and work out—all the firms offer gym memberships now. So we’ll look good, look healthy so the stress won’t show. Maybe outsiders can’t tell. But it’s clear to all of us, isn’t it?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I was a little off balance. “That lawyers aren’t happy?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“We’ve given away all our free time for as long as we can remember—all the things we cared about: family life, political commitment, travel, spirituality. We put all that energy into work. And working out so we’ll be fit enough to work so much. You know what I mean?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Her voice spiraled in pitch. This was obviously a problem she was far from solving.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“There really is a kind of seven-year itch in this profession, Laura, don’t you think? About the time we make partner we realize we blew off all the stuff that really mattered to us. I know at least a dozen lawyers who couldn’t stand it anymore, who ran off to climb some mountain in Nepal, or up and became roofers or something.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Those people come back. Usually to the same firm for less money.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I know. I know that. That was part of it. I’ve known for a long time I was unhappy, but I didn’t want to do a mid-life-crisis kind of thing. I didn’t want a consolation prize—a red Beamer or a sailboat or a trip. I wanted something real.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I didn’t like the sound of that. It’s easy to think the things you don’t have are more “real” than the things you do. Some are; most aren’t. I’d found that out the hard way with Hal.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She continued, “I was raised a Lutheran. They always told us, ‘work hard and judge not.’ But ‘judge not’ was just an aphorism on a plaque. What they really meant was ‘be like us because we’re good.’ You weren’t supposed to think or question beyond that. It’s perfect training for being a lawyer: work and conform, nonconformity is sin.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Welcome to mass culture. But then, I guess ideas are made profound by their relevance to a person’s situation. This had nothing to do with me.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I found a teacher, a real spiritual mother. Master, I mean.” She lost her look of dull enervation. Her cheeks suffused with color.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“A master?” Growing up under Hal’s mother’s thumb, I’d longed for the day I could be free. I couldn’t conceive of wanting a master.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I can tell that offends you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“No.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You can be honest, Laura.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Not if it meant getting personal. “You found a master,” I prompted.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“He’s wonderful. Totally unlike anyone else. I heard about him through a case I had. One of our debtors was a devotee. I started hanging out with the group, and suddenly it was like I was back in college. All-night conversations, brilliant people discussing the philosophy of science and the nature of reality.” She clenched her fists and stared at them. “This part’s hard. I don’t want to go into the philosophy and all that. Not that it isn’t up-and-up—it’s very scientific. He’s a physicist, quantum physics, on the cutting edge of computers and holographic-universe stuff. But that’s just detail.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I was glad my client was a lawyer. I didn’t have to sift chaff.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“In terms of why I’m here”—she reddened, looked increasingly uncomfortable—“we got into exploring various aspects of ourselves. ‘Energies,’ Brother Mike calls them. Especially negative energies, you know, things we get hung up on that become insidious, that become the basis for actions that should be independent of them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I waited. “Go on.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“A lot of us had … problems involving sexuality.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I hoped I wasn’t going to hear tales of orgies and forced sex. I hoped I wasn’t going to hear about yet another guru with Rolls Royces and love slaves.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Brother is very scientifically advanced. He believes technology is our window to the psychophysical universe.” She blinked at me, biting her lower lip. “So everything we did in terms of exploring our sexual problems we, um, did on videotape. He reimages the film on his computer.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Re")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("images? As in, ‘to image again’?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“That’s right. He changes it using graphics and animation programs. It’s very powerful. He changes it in ways that are absolutely knockout in terms of showing us things about ourselves. It’s astounding, really.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“What does he do? Put different heads on your bodies or something?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Nothing that overt. It’s more changing our expressions, imaging-in our auras—they’re like magnetic fields—showing their actions and interactions.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I looked at the well-dressed bank lawyer sitting across from me. I couldn’t believe what I was hearing. Sex videos with reimaged auras. And this was her idea of “real.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I gather some sort of problem developed?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She shrank back into the chair. “He’s released them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“The videos?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Yes. For distribution. Someone I know saw them at a video rental place. In the adult room. I guess they had a shelf labeled ‘Amateur,’ and there they were. I went and looked. There’s a dozen of them. I rented one. I’m on it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Recognizably? Or did the reimaging change you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I think I’m recognizable. I think my facial expressions”—her cheeks looked scalded—“might have been changed, but I can’t be sure.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Has he changed other people’s expressions?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I think so. But it’s such an intense experience. My memories of it are subjective. And the tapes he showed us”—her hands clutched the wool on her lap—“they had a point. The reimaging revealed things about us. Whereas the tape I rented was just sex. Even the auras are gone.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Does he narrate the tapes? Is there a plot?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She shook her head. “The one I saw was just our session.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Did you sign any kind of release?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Yes. But I never thought Brother was going to distribute the tapes. I thought the release was a formality. There are quite a few lawyers in the group—I assumed they’d advised him to be cautious, that they were protecting him. I didn’t think twice about it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("People assume lawyers are more careful than others about signing contracts. I’ve never found that to be the case.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Do you have a copy?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Not with me. I don’t even know …”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“If you want to enjoin distribution of the tapes? Seek money damages?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I guess I want to know what my options are. I guess I’m afraid to talk to Brother. He always makes sense to me, really speaks to me. You know, on a deeper level. And I guess I’m afraid of that. I’d like someone who doesn’t feel that way about him to find out why he’s doing this. Because I know he’ll make me think it was a good thing for him to do.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“And you don’t feel that way now. You feel betrayed.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She sat very still. “Brother wouldn’t betray me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("But he ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("would")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" distribute pornographic videos of you. “Tell me the name of the video rental store, and fax me a copy of the release later today. I’ll get back to you tomorrow with a report on what I saw on the videos and an opinion of the release. Then we’ll decide what you want me to say to this Brother. How would that be?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Her face crumpled. “This is very difficult for me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“If you’ll authorize the expense, I’d like to associate-in a private detective so we can get a little background information on the guru and on the extent of the video distribution. It could make a difference in terms of how you want to approach this. Information is strength.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I don’t want a battle, Laura.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You’ve been a bank lawyer long enough to know the stronger your position, the less likely you are to have to fight.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Unless it turns into an ego thing.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“True. But you don’t want that to happen. And I want what you want.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She looked at me. She knew my track record. She also knew my weakness. There were times I could have settled things more quickly by being less aggressive.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I’ll try to be careful not to screw up your spiritual relationship. But my main objective will be to get what you decide you want. If that’s an injunction against distribution, I’ll make that my priority. That’s why you need a lawyer. You’ve got a master-devotee relationship with this person. You start out from a position of supplication, so you know you’re not going to put your best interests first. Not without objective advice.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“The videos are at that place on Twenty-fourth near Army. I’ll fax the release to you. And if you really think a private detective is a good idea, I guess go ahead.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I’m sure it’s a good idea.” I knew which PI I’d contact. I hoped he’d return my call, this time.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“The other thing I wanted to tell you …” It was closer to a question than a statement. “One of the main people that—I don’t know how to put this— ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("sexualized")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(", I guess, is the best word … The main person who sort of got us all into this, who got Brother into the sexual aspects. You know, who stirred us up sexually so that Brother ended up having to help us get through some of our stuff …” She clasped and unclasped her hands, speaking to the wall behind me. “I’ve had a relationship with her.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“A relationship? Of what nature?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She told the spot behind me. “Romantic.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Okay. Is she also in the tapes?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Yes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Have you talked to her? Do you know how she feels about the distribution?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I think … I’m afraid …” Margaret finally met my eye. “I think distributing the tapes might have been Arabella’s idea.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Does that complicate things for you? Are you still having a relationship? Are you afraid this is going to jeopardize it?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Arabella is, um, a sex worker. So she … she has a lot of relationships.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“A sex worker? Is she a prostitute?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“She’s an exotic dancer. At The Back Door.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I nodded. A sex club with a reputation for being hipper than the blinking-nipples-on-billboards places on Broadway.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You say your relationship was romantic. Does that mean more than sexual?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Yes.” Her voice was husky.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“When you say she has a lot of relationships, do you mean romantic or just sexual?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Both. She’s very attractive on many levels. And not monogamous. And I don’t—” She was getting upset, short of breath. “I don’t want to lose her. I don’t want to lose Brother, either.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“But you don’t want to be recognizably featured on videos made available to the public. I’ll do my best.” I wondered if I should offer her a tissue or some wine. I wondered if I should pat her shoulder.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Corporate practice had been easy in that regard. My two criminal cases had presented more emotional complications than all my corporate cases combined.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’d never been good at dealing with emotion, mine or anyone else’s.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I was relieved when Margaret stood to leave. She fumbled in her briefcase for a moment, pulling out a flyer.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It was triple-folded blue paper. One side read fight censorship. The words jostled a collage of faces and bodies, some famous, many nude.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Arabella’s probably going to perform at this benefit. She starts work right afterward.” Margaret handed me the flyer without looking at me. “The Back Door’s giving up its main room for a couple of hours. If you need to speak to her or just want to see her. Maybe Brother’s going to be there, I don’t know. It’s tomorrow night. I probably won’t go.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Thank you.” I took the flyer. “I’ll speak to you again before then. I may want to go. It’ll depend on what’s on the tapes, and what you decide you’d like me to do.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She seemed broken, without will. I hoped it was a result of stress and confusion. I hoped it didn’t go deeper. I hoped this guru hadn’t shaken her confidence.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She was in-house counsel for a bank, after all. She couldn’t afford to get too docile.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She looked me in the eye. “It’s tearing the lesbian community apart, did you know that?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Your guru?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She pointed to the pamphlet. “That. You’ll see, if you go.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She hurried out of my office.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I unfolded the sheet of paper. “Reclaim sexuality! Reclaim erotica! Reclaim America!” it read. “Join us in speaking out against censorship. Join us for a very special show at The Back Door Theater.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tearing the lesbian community apart? I wondered what she meant.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I noticed my hand was shaking. But that had nothing to do with Margaret’s problem. It had to do with the call I was about to make.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f462f34","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FaceValue-3.vue
// module id = 75
// module chunks = 0